import VariantsPage from './VariantsPage';
export default VariantsPage;
